import React from "react";

const ScheduleModal = ({ open, onClose, message, contactId, fromMessageInput, user }) => {
  // Componente básico para permitir compilação
  // TODO: Implementar funcionalidade completa
  return null;
};

export default ScheduleModal;

